var _path, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgIconPlayButton(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 28,
    height: 28,
    viewBox: "0 0 28 28",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M14 0C6.265 0 0 6.265 0 14C0 21.735 6.265 28 14 28C21.735 28 28 21.735 28 14C28 6.265 21.735 0 14 0ZM10.5 7L21 14L10.5 21V7Z",
    fill: "url(#paint0_linear_404_2081)"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_404_2081",
    x1: 14,
    y1: 0,
    x2: 14,
    y2: 28,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F3B438"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FFC907"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconPlayButton);
export default __webpack_public_path__ + "static/media/icon-play-button.9cf442194208162d093deb23d33155b1.svg";
export { ForwardRef as ReactComponent };